import { Button, ButtonProps, Tooltip } from "@mui/material";

interface IDisabledButtonTitle extends ButtonProps {
	tooltipTitle: string;
}

export default function DisabledButtonTitle({
	disabled,
	children,
	tooltipTitle,
	...btnProps
}: IDisabledButtonTitle) {
	return <>
		{ disabled && <Tooltip title={tooltipTitle}>
			<span>
				<Button {...btnProps} disabled={true}>
					{children}
				</Button>
			</span>
		</Tooltip> }
		{ !disabled && <Button {...btnProps}>
			{children}
		</Button> }
	</>;
}
